import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbilityServiceSignal } from '@casl/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { AuthorizationModule } from '@wilson/authorization';
import { FilterModule, MultiSelectParserService } from '@wilson/filter';
import { RoleAction, RolePermissionSubject } from '@wilson/interfaces';
import { ShiftTimelineFilterStateService } from '@wilson/shift-timeline/state';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'wilson-absence-filters-group',
  templateUrl: './absence-filters-group.component.html',
  styleUrls: ['./absence-filters-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    NzCollapseModule,
    FilterModule,
    AuthorizationModule,
    NzSelectModule,
    NzTooltipModule,
    FontAwesomeModule,
  ],
})
export class AbsenceFiltersGroupComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly multiSelectParserService = inject(MultiSelectParserService);
  private readonly shiftTimelineFilterStateService = inject(
    ShiftTimelineFilterStateService,
  );

  RoleAction = RoleAction;
  RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;
  readonly faChevronUp = faChevronUp;
  readonly faChevronDown = faChevronDown;

  ngOnInit(): void {
    this.updateStateWithQueryParams();
  }

  absencesChanged(absences: string[]): void {
    this.shiftTimelineFilterStateService.absencesCategoryIds = absences;
  }

  private updateStateWithQueryParams(): void {
    const absences = this.route.snapshot.queryParams['absences'];
    this.absencesChanged(this.multiSelectParserService.unparse(absences));
  }
}
